import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import PWAInstallPage from '../../pages/PWAInstallPage';
import PWAInstallFromProfilePage from '../../pages/PWAInstallFromProfilePage';
import LoginPage from '../../pages/LoginPage';
import { APP_STATES } from '../../constants';

export default function AppRouter({
  appState,
  session,
  onPWAInstall,
  onPWASkip,
  onPWAInstallFromProfile,
  onPWASkipFromProfile,
  onLoginComplete
}) {
  switch (appState) {
    case APP_STATES.LOADING:
      return <LoadingSpinner />;

    case APP_STATES.PWA_INSTALL:
      // Не показываем PWA установку, если пользователь залогинен
      if (session) {
        return <LoadingSpinner />;
      }
      return (
        <PWAInstallPage
          onInstall={onPWAInstall}
          onSkip={onPWASkip}
        />
      );

    case APP_STATES.PWA_INSTALL_FROM_PROFILE:
      return (
        <PWAInstallFromProfilePage
          onInstall={onPWAInstallFromProfile}
          onSkip={onPWASkipFromProfile}
        />
      );

    case APP_STATES.LOGIN:
      // Не показываем страницу входа, если пользователь залогинен
      if (session) {
        return <LoadingSpinner />;
      }
      return <LoginPage onSuccess={onLoginComplete} />;

    default:
      return <LoadingSpinner />;
  }
}
